import React, { ReactNode, useEffect, useState } from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';
import { Card, CardBody, CardTitle, Row, Col } from 'reactstrap';
import api from '../../services/api';
import IDashboardData from '../../interfaces/ResumoPagamentos/IDashBoardData';
import IChartCardProps from '../../interfaces/ResumoPagamentos/ICharCardProps';
import IPaymentSummaryProps from '../../interfaces/ResumoPagamentos/IPaymentSumaryProps';

const fetchDashboardData = async () => {
  try {
    const response = await api.get('pagamentos/dashboard');
    return response.data.data as IDashboardData;
  } catch (error) {
    console.error('Erro ao buscar dados do dashboard', error);
    return null;
  }
};


export const ChartCard: React.FC<IChartCardProps> = ({ title, chart }) => (
  <Card>
    <CardBody>
      <CardTitle tag="h5">{title}</CardTitle>
      {chart}
    </CardBody>
  </Card>
);

export const PaymentSummary: React.FC<IPaymentSummaryProps> = ({ totalSales, totalValue, averageValue }) => (
  <Row>
    <Col md="16">
      <Card>
        <CardBody>
          <CardTitle tag="h5">Total de Vendas</CardTitle>
          <p className="card-category">{totalSales} vendas</p>
        </CardBody>
        <CardBody>
          <CardTitle tag="h5">Valor Faturado</CardTitle>
          <p className="card-category">R$ {totalValue}</p>
        </CardBody>
        <CardBody>
          <CardTitle tag="h5">Valor Médio de Venda</CardTitle>
          <p className="card-category">R$ {averageValue}</p>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

const Dashboard: React.FC = () => {
  const [dashboardData, setDashboardData]: any = useState(null);

  useEffect(() => {
    fetchDashboardData().then(data => {
      if (data) {
        setDashboardData(data);
      }
    });
  }, []);

  if (!dashboardData || !dashboardData.vendasPorPlano || !dashboardData.vendasPorMes) {
    return <div>Carregando...</div>;
  }

  const dataDoughnut = {
    labels: dashboardData.vendasPorPlano.nomeDosPlanos || [],
    datasets: [
      {
        data: dashboardData.vendasPorPlano.dataSets[0]?.qtdVendasPorPlano || [],
        backgroundColor: ['#82DAFF', '#02298A', '#C1ECFF', '#0575E6'],
        hoverBackgroundColor: ['#82DAFF', '#02298A', '#C1ECFF', '#0575E6'],
      },
    ],
  };


  const dataBar = {
    labels: dashboardData.vendasPorMes.nomesMeses || [],
    datasets: dashboardData.vendasPorMes.planosEVendas.map((plano: any, index: number) => ({
      label: plano.nomeDoPlano,
      backgroundColor: ['#82DAFF', '#02298A', '#C1ECFF', '#0575E6'][(index as number) % 4],
      data: plano.qtdVendasPorMes || [],
    })),
  };
  

  const optionsDoughnut = {
    cutout: '70%',
    plugins: {
      tooltip: {
      },
    },
  };
  

  const optionsBar = {
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    elements: {
      bar: {
        borderRadius: 5,
      },
    },
  };

  return (
    <Row>
      <Col md="3">
        <ChartCard title="Vendas por tipo de plano" chart={<Doughnut data={dataDoughnut} options={optionsDoughnut} />} />
      </Col>
      <Col md="4">
        <ChartCard title="Vendas por mês" chart={<Bar data={dataBar} options={optionsBar} />} />
      </Col>
      <Col md="4">
        <PaymentSummary totalSales={dashboardData.valores.totalVendas} averageValue={dashboardData.valores.valorMedio} totalValue={dashboardData.valores.valorFaturado} />
      </Col>
    </Row>
  );
};

export default Dashboard;